module.exports = __webpack_public_path__ + "static/media/Capture.5ead8c96.PNG";